import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Section from '../../../Utilitis/Section'
import TestiMonail from '../../../Utilitis/TestiMonail/TestiMonail'
import TitleSection from '../../../Utilitis/TitleSection'

export default function TestiMonials() {
    return (
        <Section bg="#F3F4F6" bg_Img={"/images/courses_background.jpg"}>
            <Container>
                <TitleSection text="TestiMonail" center title />
                <Row>
                    <Col lg={4} md={6} sm={6} xs={12}> <TestiMonail /> </Col>
                    <Col lg={4} md={6} sm={6} xs={12}> <TestiMonail /> </Col>
                    <Col lg={4} md={6} sm={6} xs={12}> <TestiMonail /> </Col>
                </Row>
            </Container>
        </Section>
    )
}
